module.exports = __webpack_public_path__ + "img/love_value_mall_poster.2acad30a.jpg";